// extracted by mini-css-extract-plugin
export default {"Navigation-desk--container":"NavigationDesk_Navigation-desk--container__2krGO"};